/* eslint-disable max-len */
import React from 'react';
import {
  Content,
  Flex, Heading, IllustratedMessage, Item, Picker, ProgressCircle, Text,
} from '@adobe/react-spectrum';
import { AnimatePresence, motion } from 'framer-motion';
import _ from 'lodash';
import { Translate } from 'react-redux-i18n';
import NoSearchResults from '@spectrum-icons/illustrations/NoSearchResults';
import ProgramTypeConfig from '../../util/programTypeConfig';
import { addCommaSeparator } from '../../util/util';
import ListingCard from '../../components/Filters/ListingCard';

export const renderSortFilter = (appliedFilters, isMobile, programPath, handleSortChange) => {
  const selectedSortValue = _.has(appliedFilters, 'sort') ? appliedFilters.sort : 'default';

  return (
    isMobile ? (
      <div className="mobileFilterSection">
        <Flex alignItems="center">
          <h4 style={{ marginRight: '10px' }}>
            Sort by:
          </h4>
          <Picker data-testid="sortingPicker" selectedKey={selectedSortValue} isQuiet UNSAFE_style={{ width: 'fit-content', marginRight: '10px' }} onSelectionChange={handleSortChange}>
            {ProgramTypeConfig[programPath]?.sortingList?.map((item) => <Item key={item.value}>{item.name}</Item>)}
          </Picker>
        </Flex>
      </div>
    ) : (
      <div className="filterSection">
        <h4>
          Sort by:
        </h4>
        <Picker data-testid="sortingPicker" selectedKey={selectedSortValue} isQuiet UNSAFE_style={{ width: 'fit-content', marginLeft: '10px' }} onSelectionChange={handleSortChange}>
          {ProgramTypeConfig[programPath]?.sortingList?.map((item) => <Item key={item.value}>{item.name}</Item>)}
        </Picker>
      </div>
    )
  );
};

export const renderResultsCounter = (loadingResults, appInitialized, totalResults) => {
  if (!loadingResults && appInitialized) {
    return (
      <motion.div
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        transition={{ ease: 'easeInOut', duration: 0.2 }}
      >
        <div className="resultsCounter">
          <Text id="result-count">{addCommaSeparator(totalResults)}</Text>
          {' '}
          <Text><Translate value="partner_finder.filters.results" /></Text>
        </div>
      </motion.div>
    );
  }
  return null;
};

export const renderLoadingIndicator = (loadingCards, loadingMoreCards) => {
  if (loadingCards && !loadingMoreCards) {
    return (
      <motion.div
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        transition={{ ease: 'easeInOut', duration: 0.25 }}
        className="loading-motion-container"
      >
        <div className="loading-cards">
          <ProgressCircle aria-label="Loading…" isIndeterminate />
        </div>
      </motion.div>
    );
  }
  return null;
};

export const renderCards = (cards, loadingCards, initialized, router, handleContactUsModal) => {
  if (_.size(cards) > 0 || loadingCards || !initialized) {
    const cardArray = Object.keys(cards).map((obj) => {
      const card = cards[obj];
      return (
        <ListingCard
          key={card.id}
          router={router}
          url={card.id}
          partnerName={card.name}
          shortDescription={card.summary}
          address={card.address}
          partnerLevel={card.level}
          partnerLogoUrl={card.logoUrl}
          certifications={card.certifications}
          specializations={card.specializations}
          customerDeployments={card.customerDeployments}
          partnerSolutions={card.solutions}
          assurancePrograms={card.assurancePrograms}
          specialized={card.specialized}
          preloading={card.preloading}
          badge={card.badge}
          listingId={card.listingId}
          data={card}
          handleContactUsModal={handleContactUsModal}
        />
      );
    });

    const cardRemainder = _.size(cards) % 3 > 0 ? 3 - (_.size(cards) % 3) : 0;

    if (cardRemainder) {
      for (let i = 0; i < cardRemainder; i += 1) {
        cardArray.push(
          <div data-testid="card-spacer" className="cmp-listing-card-spacer" key={`spacer-${i}`} />,
        );
      }
    }

    return cardArray;
  }
  return (
    <div className="no-results-container">
      <IllustratedMessage>
        <NoSearchResults />
        <Heading><Translate value="partner_finder.filters.no_results_header" /></Heading>
        <Content><Translate value="partner_finder.filters.no_results_description" /></Content>
      </IllustratedMessage>
    </div>
  );
};
